import React from "react";
import { Typography, Layout } from "antd";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = () => {
  return (
    <Layout style={{ background: "#fff" }}>
      <Content
        style={{
          padding: "60px 80px",
          maxWidth: 1000,
          margin: "0 auto",
          marginTop: "-40px",
        }}
      >
        {/* Page Heading */}
        <div
          style={{
            height: "50px",
            width: "260px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "20px auto",
            borderRadius: "20px",
            padding: "20px",
          }}
        >
          <Title level={2} style={{ margin: 0 }}>
            Privacy Policy
          </Title>
        </div>

        <Typography>
          <Paragraph>
            <Text strong>Effective Date:</Text> 1 November 2025
          </Paragraph>

          <Title level={4}>1. About Us</Title>
          <Paragraph>
            Yalla Nellab ("we", "us", "our") is a company registered in the United Arab Emirates.
          </Paragraph>
          <Paragraph>
            This Privacy Policy applies to your access and use of our website and our event services
            (football, cricket, jiujitsu, special-children events, community-labour tournaments)
            (collectively: the "Services").
          </Paragraph>

          <Title level={4}>2. What Personal Data We Collect</Title>
          <Paragraph>
            When you sign up for a Yalla Nellab event or create an account for our platform, we may
            collect the following categories of personal data:
          </Paragraph>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Details of event sign-up (which event, date, category)</li>
            <li>Account creation details</li>
          </ul>
          <Paragraph>We also use cookies and tracking technologies on our website (see section 6).</Paragraph>

          <Title level={4}>3. How We Collect Your Data</Title>
          <ul>
            <li>When you fill out our registration or event-sign-up forms.</li>
            <li>When you create an account on our website.</li>
            <li>Automatically via website cookies/tracking when you use our Services.</li>
          </ul>

          <Title level={4}>4. Why We Use Your Data</Title>
          <Paragraph>We use your personal data for the following purposes:</Paragraph>
          <ul>
            <li>To register you for events and manage your participation.</li>
            <li>
              To provide you with information about upcoming events, schedules, news and updates from
              Yalla Nellab.
            </li>
            <li>To maintain your account on our platform.</li>
          </ul>
          <Paragraph>
            We do not rent or sell your data to any third parties. We do not disclose your personal
            data to external organizations except as required by law or for the internal purposes
            described above.
          </Paragraph>

          <Title level={4}>5. Data Sharing</Title>
          <Paragraph>
            We do not share your personal data with third-party organizations for marketing or sales
            purposes. We may share personal data internally among our team members who require access
            in order to deliver our Services (e.g., event coordination staff). If any legal obligation
            arises, we may disclose data to comply with applicable laws.
          </Paragraph>

          <Title level={4}>6. Cookies and Tracking</Title>
          <Paragraph>
            We use cookies and similar tracking technologies on our website to support website
            functionality, analytics and to improve user experience. You have the option to disable
            cookies via your browser settings (though this may affect parts of our Services).
          </Paragraph>

          <Title level={4}>7. Data Retention</Title>
          <Paragraph>
            We retain your personal data for as long as your account is active or you are subscribed
            to our event updates. If you request deletion of your account or unsubscribe from our
            services, we will delete or anonymize your personal data in a timely manner unless
            retention is required by law.
          </Paragraph>

          <Title level={4}>8. Security</Title>
          <Paragraph>
            We take reasonable measures to protect your personal data from unauthorized access,
            alteration, disclosure or destruction. This includes appropriate organizational,
            technical and administrative safeguards. However, no data transmission over the internet
            or storage system is completely secure and we cannot guarantee absolute security.
          </Paragraph>

          <Title level={4}>9. Your Rights</Title>
          <Paragraph>
            Depending on your jurisdiction and the scope of your use of our Services, you may have the
            following rights:
          </Paragraph>
          <ul>
            <li>To access the personal data we hold about you.</li>
            <li>To correct or update inaccurate or incomplete data.</li>
            <li>
              To request deletion of your personal data (subject to any legal or contractual
              obligations).
            </li>
            <li>
              To unsubscribe from our event-update communications at any time through the contact us form.
            </li>
          </ul>
          <Paragraph>
            To exercise any of these rights, please contact us through our contact us form.
          </Paragraph>

          <Title level={4}>10. International Transfer of Data</Title>
          <Paragraph>
            As our company and operations are based in the UAE, your data will be processed and stored
            within the UAE or in places that meet appropriate security and data protection standards.
            If your data is transferred internationally, we will ensure an appropriate level of
            protection in line with applicable laws.
          </Paragraph>

          <Title level={4}>11. Updates to This Privacy Policy</Title>
          <Paragraph>
            We may update this Privacy Policy from time to time to reflect changes in our practices or
            legal requirements. We will publish the updated version on our website and update the
            "Effective Date" at the top. We encourage you to review this Privacy Policy periodically.
          </Paragraph>

          <Title level={4}>12. Contact Us</Title>
          <Paragraph>
            If you have any questions or concerns about our use of cookies, please contact us through
            contact us form.
          </Paragraph>
        </Typography>
      </Content>
    </Layout>
  );
};

export default PrivacyPolicy;